import { collection, doc, setDoc } from 'firebase/firestore';
import { userAsPromise } from '../providers/userProvider';
import { ITag } from '../types';

/**
 * @description update an existing tag
 * @param tag
 */
export const updateTag = async (tag: ITag): Promise<void> => {
  const user = await userAsPromise();

  await setDoc(
    doc(user.services.firestore, `/orgs/${user.orgId}/tags/${tag.id}`),
    tag,
    {
      merge: true,
    }
  );
};

/**
 * @description creates a new tag
 * @param tag
 */
export const addTag = async (tag: Partial<ITag>): Promise<void> => {
  const user = await userAsPromise();

  const ref = doc(
    collection(user.services.firestore, `/orgs/${user.orgId}/tags`)
  );

  await setDoc(ref, {
    id: ref.id,
    ...tag,
  });
};
/**
 * @description disables a tag
 * @param tag
 */
export const disableTag = async (tag: ITag): Promise<void> => {
  const user = await userAsPromise();

  await setDoc(
    doc(user.services.firestore, `/orgs/${user.orgId}/tags/${tag.id}`),
    { ...tag, active: false },
    { merge: true }
  );
};
